export default __webpack_public_path__ + "static/magazine-ro-213828e3ceae1f490b2391d91b1fbda3.png";